module.exports = __webpack_public_path__ + "static/media/p.73ed1a9a.png";